import BottomSheet from "../BottomSheet/BottomSheet"
import {
    BottomSheetContent,
    RedemptionCard,
    RedemptionRow,
    Divider,
    LabelText,
    ValueText,
    BoldValueText,
    AlertContainer
} from "./MultipartRedemptionBottomSheet.styles"
import BottomSheetHeader from "../BottomSheetHeader/BottomSheetHeader"
import AlertBox from "../AlertBox/AlertBox"
import HelpSection from "../HelpSection/HelpSection"
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader"
import { toCurrencyFormat } from "@jagad/utils"

export type MultipartRedemptionBottomSheetProps = {
    isOpen: boolean
    onClose: () => void
    enableHelpSection?: boolean
    height?: string
    requested?: string
    disbursed?: string
    inProgress?: string
    returned?: string
    isLoading?: boolean
    onContactSupport?: () => void
    // Translated strings
    title: string
    requestedLabel: string
    disbursedLabel: string
    inProgressLabel: string
    returnedLabel: string
    alertText: string
}

const MultipartRedemptionBottomSheet = ({
    isOpen,
    onClose,
    enableHelpSection,
    height = "55%",
    requested,
    disbursed,
    inProgress,
    returned,
    isLoading,
    onContactSupport,
    title,
    requestedLabel,
    disbursedLabel,
    inProgressLabel,
    returnedLabel,
    alertText,
}: MultipartRedemptionBottomSheetProps) => {
    return (
        <BottomSheet
            isOpen={isOpen}
            onClose={onClose}
            height={height}
            header={
                <BottomSheetHeader title={title} uppercase={true} />
            }
        >
            <BottomSheetContent>
                <RedemptionCard>
                    <RedemptionRow>
                        <LabelText>{requestedLabel}</LabelText>
                        <BoldValueText>{isLoading ? <SkeletonLoader width="100px" height="20px" /> : (requested === 'N/A' ? 'N/A' : `Rp${toCurrencyFormat(Number(requested))}`)}</BoldValueText>
                    </RedemptionRow>
                    <Divider />
                    <RedemptionRow>
                        <LabelText>{disbursedLabel}</LabelText>
                        <ValueText>{isLoading ? <SkeletonLoader width="100px" height="20px" /> : (disbursed === 'N/A' ? 'N/A' : `Rp${toCurrencyFormat(Number(disbursed))}`)}</ValueText>
                    </RedemptionRow>
                    <RedemptionRow>
                        <LabelText>{inProgressLabel}</LabelText>
                        <ValueText>{isLoading ? <SkeletonLoader width="100px" height="20px" /> : (inProgress === 'N/A' ? 'N/A' : `Rp${toCurrencyFormat(Number(inProgress))}`)}</ValueText>
                    </RedemptionRow>
                    <RedemptionRow>
                        <LabelText>{returnedLabel}</LabelText>
                        <ValueText>{isLoading ? <SkeletonLoader width="100px" height="20px" /> : (returned === 'N/A' ? 'N/A' : `Rp${toCurrencyFormat(Number(returned))}`)}</ValueText>
                    </RedemptionRow>
                    <AlertContainer>
                        <AlertBox alertText={alertText} />
                    </AlertContainer>
                </RedemptionCard>
                {enableHelpSection && onContactSupport && <HelpSection onContactClick={onContactSupport} />}
            </BottomSheetContent>
        </BottomSheet>
    )
}

export default MultipartRedemptionBottomSheet
